module.exports = __webpack_public_path__ + "img/Kalt.3ae59406.jpg";